.cms-blog-reference {
  .cms-blog-reference-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: transparent;
    cursor: pointer;
    transition: background-color 175ms ease 0s;
    padding: 8px;
    &:hover {
      background-color: rgb(245, 246, 246);
    }
    &:active {
      background-color: rgb(238, 239, 241);
    }
    > p,
    div {
      background-color: transparent !important;
    }
    strong{
      color:#1565c0;
    }
    > cms-icon {
      transition: transform 175ms ease 0s;
    }
  }
  .cms-toggle-close {
    cms-icon {
      transform: rotate(180deg);
    }
  }
}
